import { Fragment } from "react";
import { Col, Form, ProgressBar, Row } from "react-bootstrap";
import { AbccAssessmentCertification } from "../Models/CCAssessment";

interface IProps {
    abccAssessmentCertification: AbccAssessmentCertification;
    perCertificateArticleRequirement: number;
    perCertificateMaxFailsAllowed: number;
}

export function AbccAssessmentCertificationCard(props: IProps){
    const numPassed = props.abccAssessmentCertification.ccArticleResults?.length > 0 ? props.abccAssessmentCertification.ccArticleResults.filter(_ => _.isPass).length : 0;
    const numPassedAndWaived = props.abccAssessmentCertification.waivedArticles + numPassed;
    const numFailed = props.abccAssessmentCertification.ccArticleResults?.length > 0 ? props.abccAssessmentCertification.ccArticleResults?.filter(_ => !_.isPass).length : 0;
    const percentPassed = numPassedAndWaived / props.perCertificateArticleRequirement * 100;
    
    return(
    <Fragment>
        <Row noGutters className="align-items-center mb-0">
                <Col className="text-left col-2">
                    <Form.Label className="mb-0 pp-font-size-smaller">{props.abccAssessmentCertification.certificationName}</Form.Label> 
                </Col>
                <Col className="col-4 text-right" style={{height: "26px" }}>
                    <Form.Group controlId="articleProgress">
                        <div className="d-flex flex-row ">
                            <div className="w-75 mb-1 mt-1">
                                <ProgressBar variant="pp-secondary" role="progressbar" now={percentPassed} max={100} ></ProgressBar>
                            </div>
                            <Form.Text className="ml-1">{numPassedAndWaived}/{props.perCertificateArticleRequirement}</Form.Text>        
                        </div>                  
                    </Form.Group>
                </Col>
                <Col className="col-4 text-center" style={{height: "26px" }}>
                    <Form.Label className={"mb-0 pp-font-size-smaller " + (numFailed > props.perCertificateMaxFailsAllowed ? "pp-danger-text" : "")}>
                        {numFailed}/{props.perCertificateMaxFailsAllowed}
                    </Form.Label> 
                </Col>
                <Col className="text-center col-2">
                    <span>&nbsp;</span>
                </Col>
            </Row>
    </Fragment>
    )
}

export default AbccAssessmentCertificationCard;